import React, { useEffect, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeScannerState } from 'html5-qrcode';
import styles from './Scanner.module.css';

export default function Scanner({ onMarkScanned }) {
  const scannerRef = useRef(null);
  const callbackRef = useRef(onMarkScanned);

  useEffect(() => {
    callbackRef.current = onMarkScanned;
  }, [onMarkScanned]);

  useEffect(() => {
    const elementId = 'scanner-container';
    const qr = new Html5Qrcode(elementId);
    scannerRef.current = qr;

    qr.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 150, height: 150 } },
      decoded => callbackRef.current(decoded)
    ).catch(err => {
      console.error('Ошибка запуска сканера:', err);
    });

    return () => {
      const stopScanner = async () => {
        if (!scannerRef.current) return;

        try {
          const state = scannerRef.current.getState();
          if (
            state === Html5QrcodeScannerState.SCANNING ||
            state === Html5QrcodeScannerState.PAUSED
          ) {
            await scannerRef.current.stop();
          }
        } catch (err) {
          console.warn('Сканер уже остановлен или не запущен:', err);
        }

        try {
          await scannerRef.current.clear();
        } catch {
          /* игнорируем */
        }
      };

      stopScanner();
    };
  }, []);

  return (
    <div className={styles.scannerRoot}>
      <div id="scanner-container" className={styles.videoContainer} />
    </div>
  );
}
